import React from 'react';
import MISReportsWorkspace from '../modules/mis-reports/MISReportsWorkspace';

export default function MISReports() {
  return <MISReportsWorkspace />;
}